var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSenegal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2174 1.19072C15.6397 0.427875 13.8698 0 12 0C10.1302 0 8.36025 0.427875 6.78262 1.19072L5.73914 12L6.78262 22.8093C8.36025 23.5721 10.1302 24 12 24C13.8698 24 15.6397 23.5721 17.2174 22.8093L18.2609 12L17.2174 1.19072Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.82611L13.0358 11.0145H16.3887L13.6763 12.9853L14.7123 16.1739L11.9999 14.2033L9.28747 16.1739L10.3236 12.9853L7.61127 11.0145H10.9639L11.9999 7.82611Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78263 1.19113C2.76872 3.13208 0 7.24251 0 12C0 16.7575 2.76872 20.8679 6.78263 22.8088V1.19113Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2173 1.19113V22.8088C21.2313 20.8679 24 16.7575 24 12C24 7.24251 21.2313 3.13208 17.2173 1.19113Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenegal);
export default __webpack_public_path__ + "static/media/senegal.765978f43394fd9722de842ca57fce59.svg";
export { ForwardRef as ReactComponent };